/** @jsx isolateComponent */
import { Interpolation } from '@emotion/core';
import { Colors, Typography } from '../../../theme';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /**
   * The content to render within `FormLabelRequiredText`.
   *
   * @default Required
   */
  children?: React.ReactNode;
};

const Styles = labelStyles('FormLabelRequiredText', {
  root: {
    ...Typography.base,
    color: Colors.gray60,
    fontSize: 12,
    fontWeight: 400,
    textTransform: 'lowercase',
    '&::before': {
      content: '"("',
    },
    '&::after': {
      content: '")"',
    },
  },
});

const defaultProps = {
  children: 'Required',
};

/**
 * `FormLabelRequiredText` indicates whether a field is required.
 * Should always be a descendant of a `Label`.
 */
export const FormLabelRequiredText = (_props: Props) => {
  const props = {
    ...defaultProps,
    ..._props,
  };
  return (
    // `aria-hidden` to prevent it from being read redundantly.
    // The associated `input` field should indicate whether it's
    // required to screenreaders.
    <span aria-hidden="true" css={Styles.root as Interpolation}>
      {props.children}
    </span>
  );
};
